//local
//export const api_raiz = "http://localhost:8000/";

//qa
//export const api_raiz = "https://one.skynavieros.com:8080/skyone_qa/";

//Mexico QA
//export const api_raiz = "https://qa-one-back.skyangel.com.mx/skyone/"
//export const activeMq01 = "b-38f1e92e-651b-466a-bb79-4dc616e08590-1.mq.mx-central-1.amazonaws.com:61619";
//export const activeMq02 = "b-38f1e92e-651b-466a-bb79-4dc616e08590-2.mq.mx-central-1.amazonaws.com:61619";

// Produccion virginia
//########################################################################export const socket = "https://socket.skyangel.com.mx:8443/mensajeria_skyone/";
export const api_raiz = "https://one.skynavieros.com:8080/skyone/";
export const activeMq01 = "b-f2a56141-6c13-485e-849e-29123900f214-1.mq.us-east-1.amazonaws.com:61619";
export const activeMq02 = "b-f2a56141-6c13-485e-849e-29123900f214-2.mq.us-east-1.amazonaws.com:61619";


// PatiosBot
export const api_bot =  "https://skyiapatios.skyangel.com.mx";
export const cctv = "https://cctv.skyangel.com.mx";
export const cctvToken = "";
//export const cctv= "http://localhost";


//export const api_raiz= "https://monitoreo.skynavieros.com:8080/skyone/";